import { Component } from '@angular/core';

interface CorporateCard {
  title: string;
  description: string;
  image: string;
  alt: string;
  delay: number;
}

@Component({
  selector: 'app-mision',
  templateUrl: './mision.component.html',
  styleUrl: './mision.component.scss'
})
export class MisionComponent {
  subtitle: string = 'Nuestros Principios';
  title: string = 'Misión, Visión y Valores';
  headerDescription: string = 'Los pilares que guían cada uno de nuestros proyectos';

  cards: CorporateCard[] = [
    {
      title: 'Misión',
      description: 'Materializar las ideas y proyectos de nuestros clientes con calidad, seguridad y dedicación, mediante la mejora continua y el aprendizaje constante.',
      image: '/assets/images/home/img4.webp',
      alt: 'Misión',
      delay: 100
    },
    {
      title: 'Visión',
      description: 'Ser una de las 50 constructoras más importantes de México, creciendo gracias a la confianza de nuestros clientes.',
      image: '/assets/images/home/img8.webp',
      alt: 'Visión',
      delay: 200
    },
    {
      title: 'Valores',
      description: 'Compromiso y Honestidad; Seguridad; Calidad e Higiene; Innovación y Desarrollo.',
      image: '/assets/images/home/img3.webp',
      alt: 'Valores',
      delay: 300
    }
  ];
}
